import { InjectionToken, signal } from '@angular/core';
import { ViewTransitionInfo } from '@angular/router';

export const VIEW_TRANSITION = new InjectionToken('CURRENT_VIEW_TRANSITION', {
  factory: () => signal<ViewTransitionInfo | undefined>(undefined),
});
